const Privacy = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
        
        <div className="prose prose-blue max-w-none space-y-6 text-gray-700">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Information Collection</h2>
            <p>
              Kiwi Connect Consultants collects personal information provided by clients through consultation forms, 
              eligibility assessments, and direct communication. This information includes but is not limited to: 
              name, contact details, educational qualifications, work experience, and visa-related documentation.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Use of Information</h2>
            <p>
              All client information is used strictly for the following purposes:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Visa eligibility assessment and consultation services</li>
              <li>Preparation and filing of visa applications</li>
              <li>Communication regarding application status and updates</li>
              <li>Maintaining records as required by professional standards</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Data Protection</h2>
            <p>
              We implement appropriate security measures to protect client information from unauthorized access, 
              alteration, disclosure, or destruction. Client data is stored securely and accessed only by authorized 
              personnel for legitimate business purposes.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Information Sharing</h2>
            <p>
              Client information is not sold, traded, or shared with third parties except:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>When required for visa application submission to immigration authorities</li>
              <li>When legally required by government agencies or courts</li>
              <li>With client's explicit consent</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Client Rights</h2>
            <p>
              Clients have the right to:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Access their personal information held by us</li>
              <li>Request corrections to inaccurate information</li>
              <li>Withdraw consent for information use (subject to legal obligations)</li>
              <li>Request deletion of information after completion of services (subject to record-keeping requirements)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact</h2>
            <p>
              For privacy-related queries or requests, please contact us at:
            </p>
            <p className="font-medium">
              Email: info@kiwiconnectconsultants.com<br />
              Phone: +91 9998581146
            </p>
          </section>

          <p className="text-sm text-gray-600 mt-8 pt-6 border-t">
            Last Updated: December 2025
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
